import API from '@/views/Fdc/Apis'
import _ from 'lodash'
import BriqueChart from '@/components/BriqueChart/BriqueChart.js'

/**
 * Analysis > Multivariate Analysis - Hoteling T2
 * Hoteling T2 Tab
 */
export default {
  name: 'HotelingT2',
  components: {
  },
  beforeMount () {
    // this.initColumns()
  },
  mounted () {
    this.briqueChart = BriqueChart
  },
  computed: {
  },
  watch: {
    /**
     * summaryData 변화 감지
     */
    summaryData () {
      this.chartData = []
      this.uclPercent = 90
      this.uslPercent = 95
    }
  },
  props: {
    summaryData: {
      type: Object,
      default () {
        return null
      }
    }
  },
  methods: {
    /**
     * 감섹 Validation
     * @returns {Boolean} validation 성공 여부
     */
    _searchValidation () {
      if (!(this.summaryData.selectedVariables != null && Object.keys(this.summaryData.selectedVariables).length > 0)) {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_SELECTED', ['Features']))
        return true
      }
      if (this.summaryData.trainingModel == null) {
        this.$dialog.alert(this.$t('fdc.STATS_ANALYSIS.MESSAGE.INFORM_NOT_RUN_PCA'))
        return true
      }
      return false
    },
    /**
     * Hoteling T2 조회
     */
    async searchHotelingT2 () {
      if (this._searchValidation()) {
        return
      }
      this.summaryData.uclPercent = this.uclPercent * 0.01
      this.summaryData.uslPercent = this.uslPercent * 0.01
      const payload = {
        dataList: this.summaryData,
        modelType: 'mva'
      }

      this.$emit('save-disabled', false)
      await API.Analysis.runHotelingT2(payload, this.callback)
    },
    /**
     * Hoteling T2 조회 callback
     * @param {Object} searchData Hoteling T2 조회 결과
     */
    callback (searchData) {
      this.summaryData.ucl = searchData.ucl
      this.summaryData.usl = searchData.usl
      this.summaryData.hotelingT2 = searchData.hotelingT2
      const hotelingT2 = _.clone(this.summaryData.hotelingT2)
      // for (let i in this.summaryData.summaryDataList.datas) {
      //   let data = this.summaryData.summaryDataList.datas[i]
      //   hotelingT2.hotelingT2List[i].endDt = data.endDt
      //   hotelingT2.hotelingT2List[i].lotId = data.lotId
      //   hotelingT2.hotelingT2List[i].substId = data.substId
      // }
      // this.chartData = hotelingT2.hotelingT2List
      this.chartData = hotelingT2.hotelingT2Chart
      this.drawChartArea(hotelingT2.hotelingT2Chart)
      // this.drawChartAnnotation()
      // this.drawTraces(hotelingT2.hotelingT2List)
    },
    /**
     * Run Button 클릭
     */
    clickRun () {
      this.searchHotelingT2()
    },
    /**
     * Hoteling T2 Chart draw
     * @param {*} traces chart data 배열
     */
    drawChartArea (traces) {
      traces.map(trace => {
        trace.mode = 'markers'
        trace.type = 'scattergl'
        trace.hovertemplate = '<b>Datetime:</b> %{text.endDt|%Y-%m-%d %H:%M:%S.%L}<br><b>LOT ID:</b> %{text.lotId}<br><b>Substrate ID:</b> %{text.substId}<br><b>T2:</b> %{y:.4f}<extra></extra>'
        if (trace.name === 'UCL') {
          trace.showlegend = false
          trace.marker = {
            color: 'orange'
          }
        } else if (trace.name === 'USL') {
          trace.showlegend = false
          trace.marker = {
            color: 'red'
          }
        }
      })
      // let traces = [
      //   {
      //     name: 'index',
      //     mode: 'markers',
      //     type: 'scattergl',
      //     x: [],
      //     y: [],
      //     hovertemplate: '<b>Datetime:</b> %{text.endDt}<br><b>LOT ID:</b> %{text.lotId}<br><b>Substrate ID:</b> %{text.substId}<br><b>T2:</b> %{text.t2:.4f}<extra></extra>',
      //     text: this.chartData.filter(e => e.t2 < e.ucl).map(e => {
      //       return {
      //         lotId: e.lotId,
      //         substId: e.substId,
      //         t2: Math.round(e.t2 * 10000) / 10000.0,
      //         endDt: e.endDt
      //       }
      //     })
      //   },
      //   {
      //     name: 'UCL',
      //     mode: 'markers',
      //     type: 'scattergl',
      //     x: [],
      //     y: [],
      //     showlegend: false,
      //     marker: {
      //       color: 'orange'
      //     },
      //     hovertemplate: '<b>Datetime:</b> %{text.endDt}<br><b>LOT ID:</b> %{text.lotId}<br><b>Substrate ID:</b> %{text.substId}<br><b>T2:</b> %{text.t2:.4f}<extra></extra>',
      //     text: this.chartData.filter(e => e.t2 >= e.ucl && e.t2 < e.usl).map(e => {
      //       return {
      //         lotId: e.lotId,
      //         substId: e.substId,
      //         t2: Math.round(e.t2 * 10000) / 10000.0
      //       }
      //     })
      //   },
      //   {
      //     name: 'USL',
      //     mode: 'markers',
      //     type: 'scattergl',
      //     x: [],
      //     y: [],
      //     showlegend: false,
      //     marker: {
      //       color: 'red'
      //     },
      //     hovertemplate: '<b>Datetime:</b> %{text.endDt}<br><b>LOT ID:</b> %{text.lotId}<br><b>Substrate ID:</b> %{text.substId}<br><b>T2:</b> %{text.t2}<extra></extra>',
      //     text: this.chartData.filter(e => e.t2 >= e.usl).map(e => {
      //       return {
      //         lotId: e.lotId,
      //         substId: e.substId,
      //         t2: Math.round(e.t2 * 10000) / 10000.0,
      //         endDt: e.endDt
      //       }
      //     })
      //   }
      // ]
      let layout = {
        legend: {
          orientation: 'h',
          y: 1.2
        },
        margin: {
          r: 150
        },
        hovermode: 'closest',
        shapes: [],
        annotations: []
      }
      let config = {
        responsive: true,
        scrollZoom: true,
        displaylogo: false,
        displayModeBar: true
      }
      let promise = BriqueChart.newPlot('hotelingT2', traces, layout, config)

      promise.then(() => {
        // this.drawTraces(this.chartData)
        this.drawChartAnnotation()
      })

      // let yMin = 0; let yMax = 100; let margin = 0; const ratio = 0.2; var yValues = this.chartData.map(function (o) { return o.t2 })
      // yValues.push(this.uslVal); yValues.push(this.uclVal)
      // yMax = Math.max(...yValues)
      // yMin = Math.min(...yValues)
      // margin = (yMax - yMin) * ratio
      // this.yMin = yMin - margin
      // this.yMax = yMax + margin
    },
    /**
     * Chart Alarm Line Annotation Draw
     */
    drawChartAnnotation () {
      this.uslVal = this.summaryData.usl
      this.uclVal = this.summaryData.ucl

      let element = document.querySelector('#hotelingT2')
      if (_.isEmpty(element)) return
      let layout = element.layout
      if (_.isEmpty(layout)) return
      layout.shapes = [
        {
          type: 'line',
          xref: 'paper',
          x0: 0,
          x1: 1,
          yref: 'y',
          y0: this.uslVal,
          y1: this.uslVal,
          line: { color: 'red', width: 2 }
        }, {
          type: 'line',
          xref: 'paper',
          x0: 0,
          x1: 1,
          yref: 'y',
          y0: this.uclVal,
          y1: this.uclVal,
          line: { color: 'orange', width: 2 }
        }
      ]
      layout.annotations = [
        {
          xref: 'paper',
          x: 1,
          xanchor: 'left',
          yref: 'y',
          y: this.uslVal,
          text: 'USL: ' + Math.round(this.uslVal * 10000) / 10000.0,
          showarrow: false
        }, {
          xref: 'paper',
          x: 1,
          xanchor: 'left',
          yref: 'y',
          y: this.uclVal,
          text: 'UCL: ' + Math.round(this.uclVal * 10000) / 10000.0,
          showarrow: false
        }
      ]
      BriqueChart.relayout('hotelingT2', layout)
    }
    // drawTraces (trace) {
    //   let x = trace.filter(e => e.t2 < e.ucl).map(e => e.index)
    //   let y = trace.filter(e => e.t2 < e.ucl).map(e => e.t2)
    //   let uclX = trace.filter(e => e.t2 >= e.ucl && e.t2 < e.usl).map(e => e.index)
    //   let uclY = trace.filter(e => e.t2 >= e.ucl && e.t2 < e.usl).map(e => e.t2)
    //   let uslX = trace.filter(e => e.t2 >= e.usl).map(e => e.index)
    //   let uslY = trace.filter(e => e.t2 >= e.usl).map(e => e.t2)
    //   BriqueChart.extendTraces('hotelingT2', { x: [x, uclX, uslX], y: [y, uclY, uslY] }, [0, 1, 2])
    // }
    /**
     * null 값 check
     * @param {*} value check value
     */
    // isEmpty (value) {
    //   if (value === '' || value == null || value === undefined || (value != null && typeof value === 'object' && !Object.keys(value).length)) {
    //     return true
    //   } else {
    //     return false
    //   }
    // }
  },
  data () {
    return {
      // annotationItems: [], // Chart Annotation data 배열
      // yMin: null, // Chart y축 Min value
      // yMax: null, // Chart y축 Max value
      uclVal: null, // UCL value
      uslVal: null, // USL value
      chartData: [], // Hoteling T2 chart data
      uclPercent: 90, // UCL percent
      uslPercent: 95, // USL percent
      briqueChart: null // BriqueChart Component 객체
    }
  }
}
